module.exports = require("./mni.js");